import React from 'react';

const formatSize = (bytes) => {
  if (!bytes) return '';
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString();
};

const renderMeta = (img) => {
  const parts = [
    formatDate(img.createdTime),
    formatSize(img.size),
    img.width && img.height ? `${img.width}×${img.height}` : ''
  ].filter(Boolean);

  return parts.join(' • ');
};

const ImageGrid = ({ images, onImageClick }) => {
  const normalizedImages = images.map((img, idx) => ({
    ...img,
    _key: img.id ?? img.fileId ?? img.fileLink ?? idx,
    groupId: img.groupId ?? img.id ?? img.fileId ?? idx,
    groupSize: img.groupSize ?? 1,
    isGroupCover: img.isGroupCover ?? true,
    fullPath: img.fullPath ?? img.full_path ?? '',
  }));

  const handleClick = (img) => {
    onImageClick?.(img);
  };

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gap: '12px'
      }}
    >
      {normalizedImages.map((img) => {
        const hasGroup = (img.groupSize ?? 1) > 1;

        return (
          <div
            key={img._key}
            style={{
              textAlign: 'center',
              fontSize: '12px'
            }}
          >
            <button
              type="button"
              onClick={() => handleClick(img)}
              style={{
                display: 'block',
                position: 'relative',
                width: '100%',
                padding: 0,
                border: 'none',
                background: 'transparent',
                cursor: 'pointer'
              }}
            >
              {hasGroup && (
                <div
                  style={{
                    position: 'absolute',
                    top: '8px',
                    right: '8px',
                    zIndex: 2,
                    background: 'rgba(0, 77, 207, 0.92)',
                    color: '#fff',
                    borderRadius: '999px',
                    padding: '4px 8px',
                    fontSize: '11px',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.18)'
                  }}
                >
                  +{img.groupSize - 1}
                </div>
              )}

              <img
                src={img.thumbnailLink || img.fileLink}
                alt=""
                style={{
                  width: '100%',
                  height: '150px',
                  objectFit: 'cover',
                  borderRadius: '8px',
                  display: 'block',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  boxShadow: hasGroup
                    ? '0 0 0 1px rgba(0, 77, 207, 0.12)'
                    : '0 0 0 1px rgba(229, 231, 235, 1)'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'scale(1.03)';
                  e.currentTarget.style.boxShadow = hasGroup
                    ? '0 0 0 2px rgba(0, 77, 207, 0.35)'
                    : '0 0 0 2px rgba(156, 163, 175, 0.35)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = hasGroup
                    ? '0 0 0 1px rgba(0, 77, 207, 0.12)'
                    : '0 0 0 1px rgba(229, 231, 235, 1)';
                }}
              />
            </button>

            <div
              style={{
                marginTop: '6px',
                color: '#555',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
              title={renderMeta(img)}
            >
              {renderMeta(img)}
            </div>

            {hasGroup && (
              <div
                style={{
                  marginTop: '4px',
                  color: '#004DCF',
                  fontSize: '11px',
                  fontWeight: 500
                }}
              >
                Похожих: {img.groupSize}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ImageGrid;